import { Component } from 'react';

export class ErrorCircleSVG extends Component<{
    className?: string;
    'data-testid'?: string;
}> {
    render() {
        const { className } = this.props;

        return (
            <svg
                data-testid={this.props['data-testid']}
                className={className}
                width="90"
                height="90"
                viewBox="0 0 90 90"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g filter="url(#filter0_d)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M43 73C60.6731 73 75 58.6731 75 41C75 23.3269 60.6731 9 43 9C25.3269 9 11 23.3269 11 41C11 58.6731 25.3269 73 43 73Z"
                        fill="white"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M43 73C60.6731 73 75 58.6731 75 41C75 23.3269 60.6731 9 43 9C25.3269 9 11 23.3269 11 41C11 58.6731 25.3269 73 43 73Z"
                        stroke="#EFEFEF"
                    />
                </g>
                <rect
                    x="53.2129"
                    y="30"
                    width="2"
                    height="30"
                    rx="1"
                    transform="rotate(45 53.2129 30)"
                    fill="#DE1E1E"
                />
                <rect
                    x="32"
                    y="31.4142"
                    width="2"
                    height="30"
                    rx="1"
                    transform="rotate(-45 32 31.4142)"
                    fill="#DE1E1E"
                />
                <defs>
                    <filter
                        id="filter0_d"
                        x="0.5"
                        y="0.5"
                        width="89"
                        height="89"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        />
                        <feOffset dx="2" dy="4" />
                        <feGaussianBlur stdDeviation="6" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0689538 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow"
                            result="shape"
                        />
                    </filter>
                </defs>
            </svg>
        );
    }
}
